// extracted by mini-css-extract-plugin
export var button = "_k7-0";
export var donut = "_k7-1";
export var donutFill = "_k7-3";
export var donutTrack = "_k7-2";